var _defs, _path, _path2, _path3, _path4, _g, _g2, _rect, _rect2, _rect3, _rect4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37013",
    "data-name": "Group 37013",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 635,
    height: 635,
    viewBox: "0 0 635 635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27654",
    "data-name": "Rectangle 27654",
    width: 635,
    height: 635,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27643",
    "data-name": "Rectangle 27643",
    width: 496.523,
    height: 499.123,
    transform: "translate(90.435 87.517)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27648",
    "data-name": "Rectangle 27648",
    width: 189.429,
    height: 307.759,
    transform: "translate(225.623 166.456)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37012",
    "data-name": "Group 37012",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37011",
    "data-name": "Group 37011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37010",
    "data-name": "Group 37010",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53208",
    "data-name": "Path 53208",
    d: "M0,317.5C0,142.15,142.15,0,317.5,0S635,142.15,635,317.5,492.85,635,317.5,635,0,492.85,0,317.5",
    fill: "#f6d738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53209",
    "data-name": "Path 53209",
    d: "M24,317.328C24,155.328,155.328,24,317.328,24S610.655,155.328,610.655,317.328,479.328,610.655,317.328,610.655,24,479.328,24,317.328",
    fill: "#ffdf36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53210",
    "data-name": "Path 53210",
    d: "M48.042,317.5c0-148.818,120.641-269.458,269.458-269.458S586.958,168.682,586.958,317.5,466.318,586.958,317.5,586.958,48.042,466.318,48.042,317.5",
    fill: "#f3cc30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53211",
    "data-name": "Path 53211",
    d: "M98.3,310.1c0-115.437,93.58-209.017,209.017-209.017A208.661,208.661,0,0,1,473,182.689,208.936,208.936,0,0,0,291.756,77.848c-115.437,0-209.017,93.58-209.017,209.018A208.091,208.091,0,0,0,126.07,414.282,208.055,208.055,0,0,1,98.3,310.1",
    fill: "#ffe56f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37006",
    "data-name": "Group 37006",
    opacity: 0.673,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37005",
    "data-name": "Group 37005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37004",
    "data-name": "Group 37004",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53212",
    "data-name": "Path 53212",
    d: "M458.477,87.517A268.2,268.2,0,0,1,500.87,232.66c0,148.817-120.64,269.458-269.458,269.458A268.175,268.175,0,0,1,90.435,462.325,269.25,269.25,0,0,0,317.5,586.64c148.817,0,269.458-120.64,269.458-269.458A269.28,269.28,0,0,0,458.477,87.517",
    fill: "#edbd31"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37009",
    "data-name": "Group 37009",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37008",
    "data-name": "Group 37008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37007",
    "data-name": "Group 37007",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27644",
    "data-name": "Rectangle 27644",
    width: 39.995,
    height: 39.995,
    transform: "translate(308.203 417.117)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27645",
    "data-name": "Rectangle 27645",
    width: 39.995,
    height: 39.995,
    transform: "translate(310.384 180.797)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27646",
    "data-name": "Rectangle 27646",
    width: 82.886,
    height: 17.103,
    transform: "translate(288.916 166.456)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27647",
    "data-name": "Rectangle 27647",
    width: 82.886,
    height: 17.103,
    transform: "translate(288.941 457.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53213",
    "data-name": "Path 53213",
    d: "M328.332,425.575a102,102,0,0,1-40.708-8.017,99.448,99.448,0,0,1-32.6-22.269,102.441,102.441,0,0,1-21.645-33.671,112.412,112.412,0,0,1-7.749-42.267,116.017,116.017,0,0,1,7.571-42.356,97.987,97.987,0,0,1,54.292-55.806,105.26,105.26,0,0,1,40.841-7.839,100.958,100.958,0,0,1,39.639,7.438,92.645,92.645,0,0,1,29.663,19.731,73.842,73.842,0,0,1,17.416,26.856L381.381,283.1a54.784,54.784,0,0,0-53.049-35.622,63.7,63.7,0,0,0-34.072,8.908,61.912,61.912,0,0,0-22.937,25.12,81.821,81.821,0,0,0-8.15,37.546,82.717,82.717,0,0,0,8.15,37.723,61.684,61.684,0,0,0,22.937,25.254,63.7,63.7,0,0,0,34.072,8.908A54.916,54.916,0,0,0,381.377,355.3l33.675,15.717a73.852,73.852,0,0,1-17.414,26.945A91.929,91.929,0,0,1,367.975,417.7a100.984,100.984,0,0,1-39.643,7.879"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27649",
    "data-name": "Rectangle 27649",
    width: 39.995,
    height: 39.995,
    transform: "translate(305.368 414.282)",
    fill: "#d49a34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27650",
    "data-name": "Rectangle 27650",
    width: 39.995,
    height: 39.995,
    transform: "translate(307.55 177.962)",
    fill: "#d49a34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27651",
    "data-name": "Rectangle 27651",
    width: 82.886,
    height: 17.103,
    transform: "translate(286.081 163.621)",
    fill: "#d49a34"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27652",
    "data-name": "Rectangle 27652",
    width: 82.886,
    height: 17.103,
    transform: "translate(286.106 454.277)",
    fill: "#d49a34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53214",
    "data-name": "Path 53214",
    d: "M325.5,422.74a102,102,0,0,1-40.708-8.017,99.448,99.448,0,0,1-32.6-22.269,102.441,102.441,0,0,1-21.645-33.671,112.412,112.412,0,0,1-7.749-42.267,116.039,116.039,0,0,1,7.571-42.356,97.987,97.987,0,0,1,54.292-55.806,105.26,105.26,0,0,1,40.841-7.839,100.957,100.957,0,0,1,39.639,7.438A92.645,92.645,0,0,1,394.8,237.684a73.841,73.841,0,0,1,17.416,26.856l-33.671,15.722A54.784,54.784,0,0,0,325.5,244.64a63.7,63.7,0,0,0-34.072,8.908,61.905,61.905,0,0,0-22.937,25.12,81.821,81.821,0,0,0-8.15,37.546,82.716,82.716,0,0,0,8.15,37.723,61.684,61.684,0,0,0,22.937,25.254A63.7,63.7,0,0,0,325.5,388.1a54.916,54.916,0,0,0,53.045-35.631l33.675,15.717A73.851,73.851,0,0,1,394.8,395.13a91.928,91.928,0,0,1-29.663,19.731A100.984,100.984,0,0,1,325.5,422.74",
    fill: "#d49a34"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLogo);
export default __webpack_public_path__ + "static/media/pro-logo.84c2c35c.svg";
export { ForwardRef as ReactComponent };